<template>
  <!-- 地址薄 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="glo_btnItems" @click="clickDels()">画像标签</el-button>
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="clickTemplate">生成导入模板</el-dropdown-item>
            <el-dropdown-item command="clickImport">导入</el-dropdown-item>
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns :MoreConditions="MoreConditions" @clerBtns="clerBtns" @queryBtn_ok="queryBtn_ok" @moreParam="moreParam"></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition ref="queryForm" :More="isHaseMore" :formConfig="queryCondditionDatas"></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 新增修改 -->
    <myDialog
      :diaWidth="diaWidthDispatch"
      :dialogTitle="dialogTitleDispatch"
      :isShowDialog="isShowDialogDispatch"
      @handleCloseDia="handleCloseDiaDispatch"
      @diaCancelBtn="handleCloseDiaDispatch"
      @diaConfirmBtn="diaConfirmBtnDispatch"
    >
      <div class="formbox" v-if="isShowDialogDispatch">
        <div class="imglists">
          <div class="setper" v-if="listShipper.length">
            <div class="s_tem" v-for="(item, index) in listShipper" :key="index">
              <span>{{ item.label }}</span>
              <i class="el-icon-error" @click="clickDel(index)"></i>
            </div>
          </div>
          <el-button style="margin-top: 10px" size="small" class="glo_bgcMainColor" @click="addlistShipper">添加</el-button>
        </div>
      </div>
    </myDialog>
    <myDialog :diaWidth="diaWidth1" :dialogTitle="dialogTitle1" :isShowDialog="isShowDialog1" @handleCloseDia="handleCloseDia1" @diaCancelBtn="handleCloseDia1" @diaConfirmBtn="diaConfirmBtn1">
      <div class="formbox" v-if="isShowDialog1">
        <el-form class="glo_formBox" label-width="80px">
          <el-form-item label="新标签:" style="width: 100%">
            <el-input v-model="dialogForm1.label" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    ></exportCompoent>
    <!-- 上传组件 -->
    <input type="file" style="display: none" ref="file" @click="
        (e) => {
          e.target.value = '';
        }
      " @change="getFileData" />
    <myDialog
      :diaWidth="diaWidthDispatch1"
      :dialogTitle="dialogTitleDispatch1"
      :isShowDialog="isShowDialogDispatch1"
      @handleCloseDia="handleCloseDiaDispatch1"
      @diaCancelBtn="handleCloseDiaDispatch1"
      @diaConfirmBtn="diaConfirmBtnDispatch1"
    >
      <div class="imgprtntclass" v-if="isShowDialogDispatch1">
        <div class="filenames">{{ fileName }}</div>
        <div v-if="fileName">
          <i v-if="!isFileSuccess" class="el-icon-loading"></i>
          <i v-else style="color: #00c297" class="el-icon-success"></i>
        </div>
        <el-button class="btns" @click="uploadMaterial">选择文件</el-button>
      </div>
    </myDialog>
  </div>
</template>
<script>
import tableList from "@/pages/tableList.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/Dialog.vue";

import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
export default {
  mixins: [tableList, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "地址簿", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "SystemSetting_AddressBook", //  页面标识
      reportFiledsNumber: "admin_customer_address_list", // 动态 条件、表头

      isShowDialogDispatch: false,
      dialogTitleDispatch: "画像标签",
      diaWidthDispatch: "60%",
      listShipper: [],
      diaWidth1: "350px",
      dialogTitle1: "添加标签",
      isShowDialog1: false,
      dialogForm1: {
        label: "",
      },
      addrId: "",
      templateName: "地址薄导入模板.xlsx",
      fileNameId: "694c9de42ac92d993a01e563d4e98f4c.xlsx", //文件id
      isShowDialogDispatch1: false,
      dialogTitleDispatch1: "地址薄导入",
      diaWidthDispatch1: "350px",
      isFileSuccess: false,
      fileName: "",
      lineQuotationFile: "",
    };
  },
  mounted() {},
  watch: {},
  methods: {
    clickImport() {
      this.isShowDialogDispatch1 = true;
      this.fileName = "";
      this.isFileSuccess = false;
      this.lineQuotationFile = "";
    },
    uploadMaterial() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    // 触发上传材料文件
    getFileData() {
      const inputFile = this.$refs.file.files[0];

      const file = inputFile;
      const fileName = inputFile.name;

      this.isFileSuccess = true;
      this.fileName = fileName;
      this.lineQuotationFile = file;
    },
    handleCloseDiaDispatch1() {
      this.isShowDialogDispatch1 = false;
      this.fileName = "";
      this.isFileSuccess = false;
      this.lineQuotationFile = "";
    },
    //  弹窗确认保存事件
    diaConfirmBtnDispatch1() {
      if (!this.lineQuotationFile) {
        this.$message.error("请上传地址薄导入模板");
        return false;
      }
      const form = new FormData(); //  根据后台需求数据格式
      form.append("channelId", this.channelId);
      form.append("file", this.lineQuotationFile);
      this.$showLoading();
      this.$API.importCustomerAddrV4(form).then((res) => {
        if (res.data.status === "success") {
          this.$message.success(res.data.message || "导入成功");
          this.isShowDialogDispatch1 = false;
          this.getData();
        } else {
          this.$message.error(`${res.data.message}---导入明细`);
        }
      });
    },
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        this.$TOOLS.myModel(this);
      }
      if (a === "dtdc") {
        // 导出
        this.isShowDialog_dc = true;
      }
      if (a === "clickTemplate") {
        this.clickTemplate();
      }
      if (a === "clickImport") {
        this.clickImport();
      }
    },
    // importCustomerAddrV4
    clickTemplate() {
      let fileNames = this.fileNameId;
      let templateName = this.templateName;
      this.$API.wtl_getFileUrl({ fileName: fileNames }).then((res) => {
        let downloadurl = res.data.result.url;
        var a = document.createElement("a");
        a.style.display = "none";
        a.href = downloadurl;
        a.target = "_blank";
        a.setAttribute("download", templateName); //指定下载后的文件名，防跳转
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    },
    handleCloseDiaDispatch() {
      this.isShowDialogDispatch = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtnDispatch() {
      this.$API
        .updatePortraitLabel({
          addrId: this.addrId,
          portraitLabel:
            this.listShipper
              .map((n) => {
                return n.label;
              })
              .join() || "",
        })
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialogDispatch = false;
          this.getData();
        });
    },
    clickDels() {
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      }
      this.addrId = this.selectTableData[0].addrId;
      this.isShowDialogDispatch = true;
      let labels = this.selectTableData[0].portraitLabel || "";
      if (labels) {
        this.listShipper = labels.split(",").map((n) => {
          return {
            label: n,
          };
        });
      }
    },
    handleCloseDia1() {
      this.isShowDialog1 = false;
      this.dialogForm1 = {
        label: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn1() {
      this.listShipper.push({
        label: this.dialogForm1.label,
      });
      this.isShowDialog1 = false;
    },
    clickDel(index) {
      this.listShipper.splice(index, 1);
    },
    async addlistShipper(key) {
      this.listShipper = [];
      this.isShowDialog1 = true;
    },
  },
};
</script>
<style scoped lang="less">
.textArea {
  height: auto !important;
}
.formBox_item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .el-form-item {
    width: 32%;
  }
}
.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;

  .uploadItem {
    flex: 1;

    .uploadLaber {
      margin-bottom: 10px;
    }
  }
}
.setper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 6px;
  border: 1px dashed #cccccc;
  .s_tem {
    margin: 6px;
    .el-icon-error {
      cursor: pointer;
      color: red;
    }
  }
}
.imgprtntclass {
  padding: 20px;
  display: flex;
  align-items: center;
  .btns {
    margin-left: 16px;
  }
}
</style>